var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sign-page',{attrs:{"title-text":"质保金打款预警","request":_vm.request,"column-list":_vm.columnList,"table-size":"small","title-menus":[],"table-actions":_vm.tableActions,"table-actions-fixed":true,"need-data-file":true},on:{"tableAction":_vm.tableAction}})
}
var staticRenderFns = []

export { render, staticRenderFns }